import {Component, inject, Input, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {KtTripService} from '../service/kt-trip.service';
import {IKtCogsDetail} from '../interfaces/kt-trip.interface';

@Component({
  selector: 'app-kt-cogs-detail',
  templateUrl: './kt-cogs-detail.component.html',
  standalone: false,
})
export class KtCogsDetailComponent implements OnInit {
  @Input() public data: any;

  private readonly route = inject(ActivatedRoute);
  private readonly tripService = inject(KtTripService);

  protected readonly cogs = signal<IKtCogsDetail | null>(null);

  public ngOnInit(): void {
    const id = this.data != null ? Number(this.data) : Number(this.route.snapshot.paramMap.get('id'));
    this.tripService.getCogsById(id).subscribe(c => this.cogs.set(c));
  }
}
